import { render, staticRenderFns } from "./testMe.vue?vue&type=template&id=97150b40"
import script from "./testMe.vue?vue&type=script&lang=js"
export * from "./testMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports